<template>
  <a-modal v-model="modal" title="请编辑领料单" width="1000px" :maskClosable="false">
    <div class="pick-material-modal-css">
      <div class="example" v-if="loading">
        <a-spin />
      </div>
      <div v-for="(item, index) in dataList" :key="item.id + index" class="pick-material" v-show="!loading">
        <table border="1" class="table-style" width="100%">
          <tr>
            <td class="tac print-title" colspan="7">{{ item.businessTypeName }}MO票号：{{ item.moTicketCode }}</td>
          </tr>
          <tr>
            <td class="tac table-title">领料人</td>
            <td class="tac team-group-class">
              {{ item.teamGroupName }}
            </td>
            <td class="tac table-title">领料单号</td>
            <td class="tac" colspan="3">
              {{ item.requisitionCode }}
              <span v-if="item.isCombined==='Y'">合单</span>
            </td>
            <td class="tac" rowspan="4">
              <QrCode class="qr-code" id="moTicketPickMaterialQrCode" :text="item.moTicketCode" width="120" height="120" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">领料部门</td>
            <td class="tac">
              {{ item.workshopDesc }}
            </td>
            <td class="tac table-title">计划单号</td>
            <td class="tac" colspan="3">{{ item.orderNo }}</td>
          </tr>
          <tr>
            <td class="tac table-title">工单号</td>
            <td class="tac">{{ item.upstreamWorkNumber }}</td>
            <td class="tac table-title">成品物料名称</td>
            <td class="tac" colspan="3">{{ item.assemblyItemName }}</td>
          </tr>
          <tr>
            <td class="tac table-title">单据编号</td>
            <td class="tac">{{ item.billNo }}</td>
            <td class="tac table-title">工单总数量</td>
            <td class="tac" colspan="3">{{ item.planQuantity }}</td>
          </tr>
          <tr>
            <td class="tac table-title">成品规格描述</td>
            <td class="tac" colspan="6">{{ item.specification }}</td>
          </tr>
          <tr>
            <td class="tac table-title" width="13%">物料编码</td>
            <td class="tac table-title">物料名称</td>
            <td class="tac table-title" width="12%">派工数量（套）</td>
            <td class="tac table-title" width="11%">定量（米/平方英寸）</td>
            <td class="tac table-title" width="11%">合计</td>
            <td class="tac table-title" width="12%">领料数量</td>
            <td class="tac table-title" width="12%">补料数量</td>
          </tr>
          <tr v-if="!item.detailList || item.detailList.length===0">
            <td class="tac" colspan="7">空</td>
          </tr>
          <tr v-for="(material, materialIndex) in item.detailList" :key="material.itemCode + materialIndex">
            <td class="tac">{{ material.itemCode }}</td>
            <td class="tac" >{{ material.itemName }}</td>
            <td class="tac">
              {{ material.planQuantity }}
<!--              <a-input-number
                style="width: 100%;"
                v-model="material.planQuantity"
                :min="0"
                :max="Number(item.planQuantity || 0)"
                placeholder="请输入"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                @blur="onBlurPgsl(material)" />-->
            </td>
            <td class="tac" >{{ material.quantityPerAssembly }}</td>
            <td class="tac">{{ material.hj }}</td>
            <td class="tac">
              <a-input-number
                style="width: 100%;"
                v-model="material.llsl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
            <td class="tac">
              <a-input-number
                style="width: 100%;"
                v-model="material.blsl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">备注</td>
            <td class="tac" colspan="6">
              <a-input type="textarea" :autoSize="{minRows:2}" v-model="item.remark" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">退料</td>
            <td class="tac">
              <a-input v-model="item.tbl" placeholder="请输入" allowClear />
            </td>
            <td class="tac table-title">真皮批次</td>
            <td class="tac" colspan="4">
              <a-input class="batch-input-lg" v-model="item.zppc" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">实际用量</td>
            <td class="tac">
              <a-input-number
                style="width: 100%;"
                v-model="item.sjyl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
            <td class="tac table-title">仿皮批次</td>
            <td class="tac" colspan="4">
              <a-input class="batch-input-lg" v-model="item.fppc" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">计划生产时间</td>
            <td class="tac">
              {{ item.scheduledStartDate }}
            </td>
            <td class="tac table-title">工单交期</td>
            <td class="tac">{{ item.deliveryDate }}</td>
            <td class="tac table-title">完工时间</td>
            <td class="tac" colspan="2">
              <a-date-picker
                v-model="item.endTime"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                style="width:100%;min-width: 100%"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </td>
          </tr>
          <tr>
            <td class="tac table-title" colspan="7">
              <div class="info">
                <div class="item">仓库主管:</div>
                <div class="item">车间主管:</div>
                <div class="item">收货人:</div>
              </div>
            </td>
          </tr>
        </table>
        <div class="text-line" v-if="dataList.length>1">
          <span>第{{ index + 1 }}单&nbsp;&nbsp;共{{ dataList.length }}单</span>
        </div>
      </div>
      <div class="display-none">
        <PrintPickMaterial ref="printPickMaterialRef" id="moPrintPickMaterialId" />
      </div>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;">取消</a-button>
        <a-button type="primary" @click="checkPrint" :loading="btnLoading||loading">确认打印</a-button>
        <a-button ref="moPrintPickMaterialBtn" v-show="false" v-print="'#moPrintPickMaterialId'">打印领料单</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import PrintPickMaterial from './print-pick-material'
import moment from 'moment';
import {
  apiMesGenerateDispatchNumber
} from '@/api/mes/workOrderManage/workOrderSent'
import cloneDeep from 'lodash.clonedeep'
import QrCode from '@/components/QrCode/index.vue'
import {
  apiGetMaterialPrintListMo,
  apiUpdatePrintTimesMo
} from '@/api/mes/workOrderManage/moTickets'
export default {
  name: 'PickMaterialModal',
  components: {
    QrCode,
    PrintPickMaterial
  },
  data () {
    return {
      dataList: [],
      modal: false,
      loading: false,
      btnLoading: false,
      selectRow: []
    }
  },
  methods: {
    moment,
    // 每行派工数据合计,简单处理精度问题
    onBlurPgsl(data) {
      const total = Number(data.planQuantity || 0) * Number(data.quantityPerAssembly || 0)
      data.hj = Math.round(total * 100) / 100
      this.$forceUpdate()
    },
    show(selectRow) {
      this.selectRow = selectRow
      this.getData()
    },
    // 打印前先检查是否超出计划数量
    checkPrint() {
      this.onPrintPickMaterial() // 确定打印
    },
    // 打印
    onPrintPickMaterial() {
      this.btnLoading = true
      // 更新打印次数
      apiUpdatePrintTimesMo(this.selectRow.map(v => v.id)).then(res => {
        if (res?.code === 200) {
          this.updateData() // 更新派工数量
        } else {
          this.$message.error(res?.msg || '更新打印次数接口失败！')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 更新派工数量
    updateData() {
      this.toPrint()
      // const paramList = []
      // this.dataList.forEach(item => {
      //  if(item?.detailList?.length > 0) {
      //    item.detailList.forEach(val => {
      //      paramList.push({ mesRequirementOperationsId: val.mesRequirementOperationsId, quantity: val.planQuantity })
      //    })
      //  }
      // })
      // this.btnLoading = true
      // apiUpdateDispatchQuantityMo(paramList).then(res => {
      //   if (res?.code === 200) {
      //     this.toPrint()
      //   } else {
      //     this.$message.error(res?.msg || '更新派工数量接口失败！')
      //   }
      // }).finally(() => {
      //   this.btnLoading = false
      // })
    },
    // 生成领料单号
    generateDispatchNumber() {
      this.btnLoading = true
      apiMesGenerateDispatchNumber({ number: this.dataList.length }).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          res.data.forEach((val, index) => {
            this.$set(this.dataList[index], 'billNo', val) // 更新单据编号
          })
        } else {
          this.$message.error(res?.msg || '生成领料单号失败')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 打印领料单
    toPrint() {
      this.$refs.printPickMaterialRef.show(cloneDeep(this.dataList))
      setTimeout(() => {
        this.$refs.moPrintPickMaterialBtn.$el.dispatchEvent(new MouseEvent("click"))
        this.generateDispatchNumber() // 重新生成领料单号
        }, 200)
    },
    // 获取数据
    getData() {
      this.dataList = []
      this.loading = true
      apiGetMaterialPrintListMo(this.selectRow.map(v => v.id)).then(res => {
        this.modal = true
        if (res.data && res.data.length > 0) {
          this.dataList = res.data
          this.dataList.forEach(item => {
            if(item?.detailList?.length > 0) {
              item.detailList.forEach(material => {
                this.onBlurPgsl(material)
              })
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pick-material-modal-css{
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  padding: 0 15px;
  font-size: 15px;
}
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 30px 50px;
  margin: 20px 0;
}
.team-group-class{
  font-size: 16px;
  font-weight: 600;
}
.pick-material{
  margin: 10px auto 20px auto;
}
.display-none {
  display: none
}
.info{
  display: flex;
  justify-content: space-between;
  .item{
    text-align: left;
    padding-left: 4.2%;
    width: 33%;
  }
}
.print-title{
  font-weight: 600;
  font-size: 16px;
}
.table-title{
  font-weight: 600;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.text-line {
    text-align: center;
    position: relative;
    margin: 20px 0;
    height: 20px; /* 文本上下间距 */
}

.text-line span {
    font-style: italic;
    background-color: white; /* 与背景颜色相同以覆盖分割线 */
    padding: 0 10px; /* 文本左右间距 */
    position: absolute;
    left: 47%;
    transform: translateX(-50%);
    top: 50%;
    transform: translateY(-50%);
    color: #333; /* 文本颜色 */
}

.text-line::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 1px;
    background-color: #9a9a9a;
}
/deep/.qr-code {
  img {
    margin: auto;
  }
}
.batch-input-lg {
  width: 100%;
  /deep/ .ant-input {
    font-size: 24px;
  }
}
</style>
